module.exports = __webpack_public_path__ + "static/media/Fee-white.9e2427dc.svg";